import formatMonthKey from './formatMonthKey';
import shiftMonthKey from './shiftMonthKey';
import type { ResolveMonthParamParams } from '../types';

const MONTH_PATTERN = /^\d{4}-\d{2}$/;
const MAX_LOOKBACK_MONTHS = 24;

const resolveMonthParam = ({ monthParam, now }: ResolveMonthParamParams): string => {
    const currentMonth = formatMonthKey({ date: now });
    const earliestMonth = shiftMonthKey({ month: currentMonth, delta: -MAX_LOOKBACK_MONTHS });

    if (!monthParam || !MONTH_PATTERN.test(monthParam)) {
        return currentMonth;
    }

    if (monthParam > currentMonth) {
        return currentMonth;
    }

    if (monthParam < earliestMonth) {
        return earliestMonth;
    }

    return monthParam;
};

export default resolveMonthParam;
